import { useEffect } from 'react';
import { isObject } from 'ramda-extension';
import { useDispatch } from 'react-redux';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';

import {
	changeQuickFilter,
	loadWithQuickFilter,
	resetOrLoadUpMarketPlaceFilter,
} from 'features/views/marketPlace/actions';
import { quickFilter as quickFilterOptions } from 'features/views/marketPlace/constants';
import history from 'utils/history';
import { getRoutePath } from 'utils/routeHelper';

import Form from './Form';

const MarketPlaceFilter = () => {
	const dispatch = useDispatch();
	const formData = useFormData();
	const formIsInitiated = isObject(formData);

	const searchParams = new URLSearchParams(window.location.search);
	const searchParamsQuickFilter = searchParams.get('quickFilter');
	const hasInProgressQuickfilterPassedViaQuery = searchParamsQuickFilter === quickFilterOptions.IN_PROGRESS;

	useEffect(() => {
		if (formIsInitiated) {
			if (hasInProgressQuickfilterPassedViaQuery) {
				dispatch(changeQuickFilter(quickFilterOptions.IN_PROGRESS));
				dispatch(loadWithQuickFilter(quickFilterOptions.IN_PROGRESS));
				history.replace(getRoutePath('marketPlace'));
			} else {
				dispatch(resetOrLoadUpMarketPlaceFilter());
			}
		}
	}, [dispatch, hasInProgressQuickfilterPassedViaQuery, formIsInitiated]);

	return <Form />;
};

export default MarketPlaceFilter;
